import { useEffect, useState } from 'react'
import { useListBoards, useListSails, useLang } from '../utils/hooks'
import { langRigs } from '../assets/langRigs'
import { chartColors } from '../assets/colors'
import { cloneDeep } from 'lodash'

const RigsOptions = ({
  listRigs,
  handleAddRig,
  handleDelRig,
  handleRigsUpdate,
  canBeSaved,
  handleSave,
  disabledDemo,
}) => {
  const { listBoards } = useListBoards()
  const { listSails } = useListSails()
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langRigs.fr : langRigs.eng

  const [lists, setLists] = useState([])

  const onAddRig = () => {
    handleAddRig()
  }

  const onDelRig = () => {
    handleDelRig()
  }

  useEffect(() => {
    const onSelectChange = (event) => {
      let data = cloneDeep(listRigs)
      const type = event.target.id.substring(0, 1)
      const index = parseInt(event.target.id.substring(1))
      const val = event.target.value
      switch (type) {
        case 'b':
          data[index].boardId = val
          break
        case 's':
          data[index].sailId = val
          break
        default:
          break
      }
      handleRigsUpdate(data)
    }

    let rigs = []

    for (let i = 0; i < listRigs.length; i++) {
      const rigBoardId = listRigs[i].boardId
      const rigSailId = listRigs[i].sailId
      let boardsOptions = []
      let sailsOptions = []
      boardsOptions.push(
        <option value="-1" disabled hidden key="0">
          {'choose board'}
        </option>
      )
      listBoards.initialData.map((board) => {
        boardsOptions.push(
          <option value={board._id} key={board._id}>
            {board.volume + ' ' + board.brand + ' ' + board.model}
          </option>
        )
        return null
      })

      sailsOptions.push(
        <option value="-1" disabled hidden key="0">
          {'choose sail'}
        </option>
      )
      listSails.initialData.map((sail) => {
        sailsOptions.push(
          <option
            value={sail._id}
            // selected={rigSailId === sail._id}
            key={sail._id}
          >
            {sail.surface.toFixed(1) + ' ' + sail.brand + ' ' + sail.model}
          </option>
        )

        return null
      })
      rigs.push(
        <>
          <div className={'field mb-1 mr-2 p-2 ' + chartColors[i].lighttag}>
            <label className="label is-small">{'# ' + (i + 1)}</label>

            <div>
              <div className="field is-horizontal ">
                <div className="field-label is-size-6-desktop is-size-7-mobile">
                  <label className="label">{choosenLang.board}</label>
                </div>

                <div className="field-body">
                  <div className="field is-narrow">
                    <div className="control">
                      <span
                        className={
                          ' select is-size-6-desktop is-size-7-mobile ' +
                          chartColors[i].tag
                        }
                      >
                        <select
                          id={'b' + i}
                          onChange={onSelectChange}
                          value={rigBoardId}
                        >
                          {boardsOptions}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label is-size-6-desktop is-size-7-mobile">
                  <label className="label">{choosenLang.sail}</label>
                </div>
                <div className="field-body">
                  <div className="field is-narrow">
                    <div className="control ">
                      <span
                        className={
                          ' select is-size-6-desktop is-size-7-mobile' +
                          chartColors[i].tag
                        }
                      >
                        <select
                          id={'s' + i}
                          onChange={onSelectChange}
                          value={rigSailId}
                        >
                          {sailsOptions}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )

      // if (i < 3) {
      //   firstLineRigs.push(temp)
      // } else if (i < 6) {
      //   secondLineRigs.push(temp)
      // } else {
      //   thirdLineRigs.push(temp)
      // }

      // rigs.push(
      //   <>
      //     <div className={'column is-3 ' + chartColors[i].lighttag}>
      //       <label className="label is-small">{'# ' + (i + 1)}</label>

      //       <div>
      //         <div className="field is-horizontal ">
      //           <div className="field-label is-small">
      //             <label className="label">{choosenLang.board}</label>
      //           </div>

      //           <div className="field-body">
      //             <div className="field">
      //               <div className="control">
      //                 <span
      //                   className={' select is-small ' + chartColors[i].tag}
      //                 >
      //                   <select
      //                     id={'b' + i}
      //                     onChange={onSelectChange}
      //                     value={rigBoardId}
      //                   >
      //                     {boardsOptions}
      //                   </select>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>

      //         <div className="field is-horizontal">
      //           <div className="field-label is-small">
      //             <label className="label">{choosenLang.sail}</label>
      //           </div>
      //           <div className="field-body">
      //             <div className="field">
      //               <div className="control ">
      //                 <span
      //                   className={' select is-small ' + chartColors[i].tag}
      //                 >
      //                   <select
      //                     id={'s' + i}
      //                     onChange={onSelectChange}
      //                     value={rigSailId}
      //                   >
      //                     {sailsOptions}
      //                   </select>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </>
      // )
    }

    setLists(rigs)
  }, [listRigs, listBoards, listSails])

  return (
    <>
      <div className="columns ">
        <div className="column is-narrow">
          <div className="field is-grouped">
            <p className="control">
              <button
                className="button is-info is-small"
                onClick={onAddRig}
                title="Ajouter un rig"
                disabled={listRigs.length > 7}
              >
                +
              </button>
            </p>
            <p className="control">
              <button
                className="button is-info is-small"
                onClick={onDelRig}
                title="Supprimer la sélection de points"
              >
                -
              </button>
            </p>
          </div>
          <div className="field">
            <p className="control">
              <button
                className="button is-primary is-small"
                onClick={handleSave}
                disabled={!canBeSaved || disabledDemo}
                title={disabledDemo ? choosenLang.registeredOnly : ''}
              >
                {choosenLang.save}
              </button>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="field is-horizontal is-grouped is-grouped-multiline">
            {lists}
          </div>
          {/* {lists.secondLine.length > 0 && (
            <div className="field is-horizontal is-grouped-multiline">
              {lists.secondLine}
            </div>
          )}
          {lists.thirdLine.length > 0 && (
            <div className="field is-horizontal is-grouped-multiline">
              {lists.thirdLine}
            </div>
          )} */}
        </div>
        {/* <div className="column ">
          <div className="columns is-multiline">
            {lists.length > 0 && lists}
          </div>
        </div> */}
      </div>
    </>
  )
}

export default RigsOptions
